module.exports = __webpack_public_path__ + "static/scott-a7851d29482aec2ef36d9da62202ab80.jpg";